import workReducers from './reducers';

// export { default as workSelectors } from './selectors';
export {default as workOperations} from './operations';
export {default as workTypes} from './types';

export default workReducers;
